/**
 * effectiveRole — display-only role override for admins.
 *
 * Admins can toggle a `viewMode` (constructor / marketing / investor) to
 * preview what those users see. This helper returns the role that should
 * drive *navigation and dashboard chrome* — never permission gates. Backend
 * permissions and client-side gating (e.g. canConvert) stay anchored on the
 * real role.
 */
import { useAuth } from "@/lib/auth";

export const VIEW_MODE_OPTIONS = [
  { value: "admin",       label: "Vista Admin",       labelEn: "Admin view" },
  { value: "constructor", label: "Vista Constructor", labelEn: "Constructor view" },
  { value: "marketing",   label: "Vista Marketing",   labelEn: "Marketing view" },
  { value: "investor",    label: "Vista Inversor",    labelEn: "Investor view" },
];

/** Return the role that should drive nav + dashboard rendering. */
export function useEffectiveRole() {
  const { user, viewMode } = useAuth();
  if (!user) return null;
  if (user.role !== "admin") return user.role;
  return viewMode || user.role;
}

/** True if the current user is allowed to switch views (admin only). */
export function useCanSwitchView() {
  const { user } = useAuth();
  return user?.role === "admin";
}

export function viewModeLabel(mode, lang = "es") {
  const opt = VIEW_MODE_OPTIONS.find(o => o.value === mode);
  if (!opt) return mode;
  return lang === "en" ? opt.labelEn : opt.label;
}
